import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { cx } from '@libs/classnames';
import useLockBodyScroll from '@libs/hooks/useLockBodyScroll';

import styles from './Modal.module.css';

type Props = {
  className?: string;
  open?: boolean;
  children: ReactNode;
};
export function Modal({ className, open, children }: Props) {
  useLockBodyScroll(open);
  return createPortal(
    open && (
      <div className={cx(styles.modalContainer, className)}>
        <div className={styles.modal}>{children}</div>
      </div>
    ),
    document.body,
  );
}
